import * as React from 'react';
import { useEffect, useState } from 'react';
import { isFunction } from "../helpers/utils";
import { type AssetData, AssetMode } from "./asset.interface";
import {
	defAssetQuality,
	getAssetImageFormatFromFileExtension,
	getFileExtensionFromFilename,
	getFileNameWithoutExtension,
	getImgUrl
} from "./assetUtils";
import SelectAssetImage, { type SelectAssetImageCommonProps } from "./selectAssetImage";

interface Props extends SelectAssetImageCommonProps {
	imageWidth: number,
	imageHeight: number,
	src: string,
	onChangeSrc?: Function,
}

function SelectAssetImageSrc({
	imageWidth = 0,
	imageHeight = 0,
	previewWidth = 320,
	previewHeight = 240,
	mode = AssetMode.Thumb,
	src,
	onChangeSrc,
	allowClear = true,
	showModalOnRender = false,
	...otherProps
}: Props) {

	const [asset, setAsset] = useState<AssetData>(null);

	const parts = src.split('/');
	let fileName = parts.pop();
	let fileExtension = getFileExtensionFromFilename(fileName);
	let format = getAssetImageFormatFromFileExtension(fileExtension);
	console.log(src, parts, fileName, fileExtension, format);

	let assetId = parseInt(parts.find((element) => {
		return element.match(/^\d+$/) !== null;
	}));
	//console.log(assetId);

	let quality = defAssetQuality;
	let sizesPart = parts.find((element) => {
		return element.match(/^\d+_\d+_\d{1,3}$/) !== null;
	});

	if (sizesPart) {
		let sizesPartArray = sizesPart.split('_');
		if (Array.isArray(sizesPartArray) && sizesPartArray.length === 3) {
			quality = parseInt(sizesPartArray.pop());
		}
	}
	//console.log(sizesPart, sizesPart.length, quality);


	function updateSrc(mode: AssetMode, id: number, filename = '', quality = defAssetQuality) {
		if (isFunction(onChangeSrc)) {
			onChangeSrc(getImgUrl(mode, id, filename, imageWidth, imageHeight, quality));
		}
	}

	useEffect(() => {
		updateSrc(mode, assetId, fileName, quality);
	}, [mode, imageWidth, imageHeight]);

	return (<>
		<SelectAssetImage
			previewWidth={previewWidth}
			previewHeight={previewHeight}
			mode={mode}
			allowClear={allowClear}
			showModalOnRender={showModalOnRender}
			assetId={assetId}
			onChange={(newAsset: AssetData) => {
				setAsset(newAsset);
				//console.log(newAsset?.id, assetId);
				if (newAsset?.id !== undefined && newAsset.id !== assetId) {
					updateSrc(mode, newAsset?.id, newAsset?.filename, quality);
				}
			}}
			format={format}
			onChangeFormat={(newFormat) => {
				updateSrc(mode, assetId, getFileNameWithoutExtension(fileName) + '.' + newFormat, quality);
			}}
			quality={quality}
			onChangeQuality={(newQuality) => {
				updateSrc(mode, assetId, fileName, newQuality);
			}}
			{...otherProps}
		/>
	</>);
}

export default SelectAssetImageSrc;
